const getLoadedStatus = (rootState) => rootState.ui.editor.isLoaded;

export default getLoadedStatus;
